import React, { useState, useRef, useEffect } from 'react';
import styles from './index.module.scss';
import Content2 from './content2';
import Content3 from './content3';
import CustomCarousel from './banner';
import LazyImage from '@/components/LazyImage'; // 引入懒加载组件

const Home = () => {
    const [state] = useState({
        bannerFlag: true,
    });

    const menuItems = [
        { normal: 'ABOUT US', hover: 'ABOUT US1', target: 'about' },
        { normal: 'SERVICE', hover: 'SERVICE1', target: 'service' },
        { normal: 'ENGAGEMENT', hover: 'ENGAGEMENT1', target: 'engagement' },
        { normal: 'CONTACT US', hover: 'CONTACT US1', target: 'contact' }
    ];

    const [hoverIndex, setHoverIndex] = useState(null);
    const menuRef = useRef(null);
    const [menuFlag, setMenuFlag] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => setMenuFlag(!entry.isIntersecting),
            { threshold: 0 }
        );

        if (menuRef.current) {
            observer.observe(menuRef.current);
        }

        return () => observer.disconnect();
    }, []);

    const handleClick = (item) => {
        const element = document.getElementById(item.target);
        element?.scrollIntoView({ behavior: 'smooth' });
    };

    const handleTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className={styles['content']}>
            <div className={styles['banner']}>
                <div
                    ref={menuRef}
                    className={styles['menuheight']}
                    style={{ position: 'absolute', top: 0, zIndex: '-100' }}
                ></div>

                <div className={menuFlag ? styles['menu'] : ''}>
                    <div className={styles['top-content']}>
                        <img
                            alt=''
                            src={require('@/assets/image/menu/LOGO.png')}
                            onClick={handleTop}
                            style={{ width: '17vw', cursor: 'pointer' }}
                            loading="lazy"
                        />
                    </div>
                    <div className={styles['menu-content']}>
                        {menuItems.map((item, index) => (
                            <div
                                key={index}
                                onMouseEnter={() => setHoverIndex(index)}
                                onMouseLeave={() => setHoverIndex(null)}
                                onClick={() => handleClick(item)}
                                style={{ cursor: 'pointer' }}
                            >
                                <img
                                    alt=""
                                    src={require(`@/assets/image/menu/${
                                        hoverIndex === index ? item.hover : item.normal
                                    }.png`)}
                                    className={styles['menu-img']}
                                    loading="lazy"
                                />
                            </div>
                        ))}
                    </div>
                </div>

                <div>
                    <CustomCarousel bannerFlag={state.bannerFlag} />
                </div>

                <Content2 />

                <div>
                    <LazyImage
                        alt=""
                        src={require('@/assets/image/拆分底图 2.jpg')}
                        style={{ width: '100%', padding: 0, margin: 0 }}
                    />
                </div>

                <div id="service">
                    <LazyImage
                        alt=""
                        src={require('@/assets/image/拆分底图 4.jpg')}
                        style={{ width: '100%', padding: 0, margin: 0 }}
                    />
                </div>

                <Content3 />

                <div id="contact">
                    <LazyImage
                        alt=""
                        src={require('@/assets/image/底部.jpg')}
                        style={{ width: '100%' }}
                    />
                </div>
            </div>
        </div>
    );
};

export default Home;
